import React from 'react';
import errorImg from '../../images/2452575.jpg'

const NotFound = () => {
    return (
        <div className="container-fluid p-0">
            <img className="img-fluid" src={errorImg} alt="" />
        </div>
    );
};

export default NotFound;